// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import Outcome from '../components/Outcome';
import OutcomeBetbuilder from '../components/OutcomeBetbuilder';
import { selectBetShareOutcome } from '../selectors';

type PropsType = {
  forwardRef: unknown;
  betslipReference: string;
  outcomeId: number;
  x: number;
  y: number;
  odds: unknown;
  isLast: boolean;
};

const OutcomeContainer = (ownProps: PropsType) => {
  const selectedProps = useSelector((state) => selectBetShareOutcome(state, ownProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  if (enhancedProps.isBetbuilder) {
    return <OutcomeBetbuilder {...enhancedProps} />;
  }
  return <Outcome {...enhancedProps} />;
};

export default OutcomeContainer;
